
import BoardMarquee from "@/components/BoardMarquee.vue"
import AutocallButtonCert from "@/components/autocall/AutocallButtonCert.vue"
import AutocallButtonOff from "@/components/autocall/AutocallButtonOff.vue"
import AutocallInputCar from "@/components/autocall/AutocallInputCar.vue"
import AutocallTextInput from "@/components/autocall/AutocallTextInput.vue"

import ButtonIcon from "@/components/ButtonIcon.vue"
import ButtonBig from "@/components/ButtonBig.vue"

import { defineComponent, computed, onMounted } from "vue"
import { useStore } from "vuex"
import { useRoute } from "vue-router"
import HeaderLogo from "@/components/HeaderLogo.vue"

export default defineComponent({
  components: {
    BoardMarquee,
    AutocallTextInput,
    AutocallInputCar,
    AutocallButtonCert,
    AutocallButtonOff,
    ButtonIcon,
    ButtonBig,
    HeaderLogo,
  },
  setup() {
    const { state, commit, dispatch } = useStore()
    const { query } = useRoute()
    const { hashistory, type } = query
    const isCarChecked = computed(() => state.autocall.isCarChecked)

    commit("autocall/SET_CARNUMBER", "")

    onMounted(() => {
      if (type === "SMS") dispatch("callgate/startVARS")
    })

    return {
      isCarChecked,
      hashistory,
    }
  },
})
